import {FC} from 'react'
import {toAbsoluteUrl} from '_metronic/helpers'
import {getProductImageUrl} from 'app/utilities'

type Props = {
  product: any
  className?: string
}

const ProductImage: FC<Props> = ({product, className}) => {
  let url = ''
  if (product?.imageSrc) {
    url = getProductImageUrl({id: product.id, src: product.imageSrc})
  } else {
    url = toAbsoluteUrl(`/media/images/product-default.jpg`)
  }

  return (
    <div
      className={className ? className : 'w-50px h-50px'}
      style={{
        backgroundImage: `url(${url})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    />
  )
}

export default ProductImage
